import personalAccount from "@/plugins/api/factories/PersonalAccount";

export const state = {
  response: null,
  personalAccountData: null,
  ls: null,
  meterDigits: null,
};

export const mutations = {
  SET_RESPONSE(state, response) {
    state.response = response;
  },
  SET_LS(state, ls) {
    state.ls = ls;
  },
  SET_METER_DIGITS(state, meterDigits) {
    state.meterDigits = meterDigits;
  },
  GET_PERSONAL_ACCOUNT_DATA(state, personalAccountData) {
    state.personalAccountData = personalAccountData;
  },
};

export const actions = {
  async setPersonalAccountData({ state, commit }) {
    return await personalAccount.setKirovogradEnergoDataForPersonalAccount({ls: state.ls, meterDigits: state.meterDigits}, (response) => {
        commit("SET_RESPONSE", response);
    });
  },
  async getPersonalAccountData({ commit }) {
    return personalAccount.getKirovogradEnergoDataForPersonalAccount((response) => {
      commit("SET_RESPONSE", response);
    });
  },
};
